/**
 * @description 格式化常量
 * @created 2024/04/26 15:33:00
 */

// 年月日
export const FORMAT_DATE = "YYYY-MM-DD"

// 年月日 时分秒
export const FORMAT_DATETIME = "YYYY-MM-DD HH:mm:ss"
